import { useCallback } from "react";

import { clsx } from "clsx";
import dayjs, { Dayjs } from "dayjs";

import { RVDatePickerDayJSFacade, DateFormat } from "@regal-voice/ui";

import styles from "../ConditionalFormItems.module.scss";

type DatePickerItemProps = {
    value?: any;
    onChange?: (value: string | undefined) => void;
    placeholder?: string;
    testId?: string;
    disabled?: boolean;
};

export function DatePickerItem({ value, onChange, placeholder, testId, disabled }: DatePickerItemProps): JSX.Element {
    const dateValue = value ? dayjs(value) : null;

    const onDateChange = useCallback(
        (newDate: Dayjs | null) => {
            let value;
            if (newDate) {
                value = newDate.format("YYYY-MM-DDTHH:mm:00");
            }
            onChange?.(value);
        },
        [onChange]
    );

    return (
        // TODO this should be replaced with an RVDatePicker
        <RVDatePickerDayJSFacade
            picker={undefined}
            placeholder={placeholder}
            format={DateFormat.DATE_TIME_TZ_INDEPENDENT}
            onChange={onDateChange}
            onSelect={onDateChange}
            value={dateValue}
            className={clsx(styles.datetimeBorder)}
            data-testid={testId}
            disabled={disabled}
            showNow={false}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            showTime={{
                format: DateFormat.PRETTY_SHORT_TIME_DEFAULT,
                use12Hours: true,
            }}
        />
    );
}
